(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    // script.js
function getUrlParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
}

function selectOptionsFromUrlParams() {
    const make = getUrlParameter('make');
    const model = getUrlParameter('model');
    const year = getUrlParameter('year');

    if (make) {
        const makeSelect = document.getElementById('make');
        makeSelect.value = make; // Set the selected value for make
    }

    if (model) {
        const modelSelect = document.getElementById('model');
        modelSelect.value = model; // Set the selected value for model
    }

    if (year) {
        const yearSelect = document.getElementById('year');
        yearSelect.value = year; // Set the selected value for year
    }
}

// Call the function to select options based on URL parameters
selectOptionsFromUrlParams();
  } catch(e) { console.error(e); }
})();

})();
